// src/components/LoadingScreen.js
import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => (
  <div className="loading-screen">ברוכים הבאים ;)</div>
);

export default LoadingScreen;
